'use server'

interface PriceRange {
    minPrice: number
    maxPrice: number
}

type PriceRangeParams = Record<
    string,
    string | string[] | undefined
>

export async function getProductsPriceRange(
    paramsObj: PriceRangeParams,
): Promise<PriceRange> {
    try {
        const params = new URLSearchParams()

                Object.entries(paramsObj).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach((item) => {
                    params.append(key, item)
                })
            } else if (value) {
                params.set(key, value)
            }
        })

        const res = await fetch(
            `${process.env.API_URL_PRODUCTS}/filters?${params.toString()}`,
            { cache: 'no-store' },
        )

        if (!res.ok) {
            console.warn('[getProductsPriceRange] HTTP error:', res.status)
            return { minPrice: 0, maxPrice: 0 }
        }
        const contentType = res.headers.get('content-type')
        if (!contentType?.includes('application/json')) {
            console.warn(
                '[getProductsPriceRange] Ответ не JSON, возвращаем дефолт',
                contentType,
            )
            return { minPrice: 0, maxPrice: 0 }
        }
        const data = await res.json()
        return data
    } catch (err) {
        console.error('[getProductsPriceRange] Ошибка fetch:', err)
        return { minPrice: 0, maxPrice: 0 }
    }
}

interface ProductsProps {
    category_id?: string
    page?: number
    limit?: number
    // color?: string[]
    color?: string
    minPrice?: number
    maxPrice?: number
    size?: string
    section?: string[]
    gender?: string
    season?: string
    available?: boolean
}

export async function getProducts({
    category_id,
    page = 1,
    limit = 6,
    color,
    section,
    gender,
    season,
    size,
    minPrice,
    maxPrice,
    available,
}: ProductsProps = {}) {

    try {


    if ((minPrice === undefined || maxPrice === undefined) && category_id) {
        const range = await getProductsPriceRange({
            category_id,
            color,
            section,
            gender,
            season,
            size,
            available: available !== undefined ? String(available) : undefined,
        })
        if (minPrice === undefined) minPrice = range.minPrice
        if (maxPrice === undefined) maxPrice = range.maxPrice
    }

    const params = new URLSearchParams()
    if (page) params.set('page', String(page))
    if (limit) params.set('limit', String(limit))
    if (category_id) params.set('category_id', category_id)

    if (size) {
        params.set('size', size)
        console.log('вот САЙЗ', size)
    }
    if (color) {
        params.set('color', color)
        console.log('вот САЙЗ', color)
    }
    if (section?.length) {
    section.forEach((value) => {
        params.append('section', value)
    })

    console.log('вот section', section)
}
    if (gender) {
        params.set('gender', gender)
        console.log('вот gender', gender)
    }
    if (season) {
        params.set('season', season)
        console.log('вот season', season)
    }
    if (available !== undefined) params.set('available', String(available))

    if (minPrice !== null) params.set('min_price', String(minPrice))
    if (maxPrice !== null) params.set('max_price', String(maxPrice))

    const res = await fetch(
        `${process.env.API_URL_PRODUCTS}?${params.toString()}`,
        {
            next: { revalidate: 0 },
        },
    )

    const raw = await res.clone().text()

    if (res.status === 404) {
        try {
            const json = JSON.parse(raw)
            if (json?.error === 'Product not found') {
                return { data: [], total: 0 }
            }
        } catch (e) {}
    }

    if (!res.ok) {
        console.error('SERVER ERROR:', raw)
        return { data: [], total: 0 }
    }
    return await res.json()
        } catch (err) {
             console.error('[getProducts] Ошибка fetch:', err)
                return { data: [], total: 0 }
    
}
}

export async function getProductById(productId: string) {
    if (!productId) return null
    console.log('продуктовый айди на сервере со страниццы product',productId )
    try {
        const res = await fetch(`${process.env.API_URL_PRODUCTS}/${productId}`)
        if (!res.ok) {
            console.warn(
                `[getProductById] Продукт ${productId} не найден или сервер вернул ошибку`,
            )
            return null
        }
        const contentType = res.headers.get('content-type')
        if (!contentType?.includes('application/json')) {
            console.warn(
                `[getProductById] Продукт ${productId} вернул не JSON:`,
                contentType,
            )
            return null
        }
        const data = await res.json()
        return data
    } catch (err) {
        console.error(`Ошибка при запросе продукта ${productId}:`, err)
        return null
    }
}

export async function getAllProducts(opts?: { page?: number; limit?: number }) {
    try {
        const params = new URLSearchParams()
        if (opts?.page) params.set('page', String(opts.page))
        if (opts?.limit) params.set('limit', String(opts.limit))

        const url = `${process.env.API_URL_PRODUCTS}${params.toString() ? `?${params.toString()}` : ''}`

        const res = await fetch(url, { cache: 'no-store' })
        if (!res.ok) {
            console.warn(
                '[getAllProducts] HTTP error:',
                res.status,
                res.statusText,
            )
            return []
        }

        const contentType = res.headers.get('content-type')

        if (!contentType?.includes('application/json')) {
            console.warn('[getAllProducts] Response is not JSON:', contentType)
            return []
        }

        const data = await res.json()

        return data
    } catch (err) {
        console.error('[getAllProducts] Fetch failed:', err)
        return []
    }
}
